import { createComponent } from '@carvana/merch-components';
import React, { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const Svg = createComponent<OwnProps>('svg', {
  className: '-:h-[17px] -:w-[17px] -:text-white'
});

export default forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 17"
    fill="none"
    ref={ref}
    {...props}
  >
    <path
      d="M10.11 13.2002L15.11 8.20011M15.11 8.20011L10.11 3.20019M15.11 8.20011L1.10999 8.2001"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
));
